import { Component } from '@angular/core';

@Component({
  selector: 'unh-dropdown-list',
  styleUrls: ['./dropdown-list.component.scss'],
  template: `
    <div>
      <ng-content></ng-content>
    </div>
  `
})
export class DropdownListComponent {}
